import React, { useEffect, useState } from 'react'
import { TermsWrap } from './styles'
import { PolicyAction } from '../../store/action'

const Terms = () => {

  // Policy Action
  const { getPolicyList } = PolicyAction()

  const [pagination, setPagination] = useState({
    page: 0,
    size: 10
  })

  const [terms, setTerms] = useState('')

  useEffect(() => {
    getPolicyList(pagination)
    .then((res) => {
      const data = res?.payload.data?.filter((item: any) => item.code === 'tos' && item.required === 1)[0]
      setTerms(data?.content)
    })
  }, [])

  return (
    <TermsWrap>
      <div className="container">
        <div className="box-wrap">
          <div className="title-wrap">
            <h2>이용약관</h2>
          </div>
          <div className="contents-wrap">
            <div className="contents" dangerouslySetInnerHTML={{ __html: terms }} />
          </div>
        </div>
      </div>
    </TermsWrap>
  )
}

export default Terms